import { render, staticRenderFns } from "./CompanyAttendanceCorrectionsCutOff.vue?vue&type=template&id=25cfb324"
import script from "./CompanyAttendanceCorrectionsCutOff.vue?vue&type=script&lang=js"
export * from "./CompanyAttendanceCorrectionsCutOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports